export const LOGIN_STRINGS = {
  en: {
    TITLE: 'Log in',
    STEP: 'Step 1 of 2',
  },
  sv: {
    TITLE: 'Logga in',
    STEP: 'Steg 1 av 2',
  },
  nb: {
    TITLE: 'Logg inn',
    STEP: 'Steg 1 av 2',
  },
  da: {
    TITLE: 'Log ind',
    STEP: 'Step 1 af 2',
  },
} as const
